module.exports = __webpack_public_path__ + "static/img/client3.d76b7ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client3.png
// module id = 53V7
// module chunks = 1